(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gp-scripts"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const $ = (q, root = document) => root.querySelector(q);
  const $$ = (q, root = document) => [...root.querySelectorAll(q)];
  const strings = JSON.parse($('#gp-copy')?.textContent || '{}');
  const say = key => strings[key] || key;
  const emit = (event, details = {}) => {
    if (document.documentElement.dataset.preview === 'true') return;
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    const allowed = ['category', 'model', 'step', 'source'];
    const safe = Object.fromEntries(Object.entries(details).filter(([k]) => allowed.includes(k)));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...safe });
    window.Shopify?.analytics?.publish?.(event, safe);
  };
  if (document.documentElement.dataset.preview !== 'true' && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  document.documentElement.classList.replace('no-js', 'js');
  const menu = $('[data-menu-toggle]');
  const nav = $('#mobile-nav');
  menu?.addEventListener('click', () => {
    const expanded = menu.getAttribute('aria-expanded') !== 'true';
    menu.setAttribute('aria-expanded', String(expanded));
    nav.hidden = !expanded;
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && nav && !nav.hidden) {
      nav.hidden = true; menu.setAttribute('aria-expanded', 'false'); menu.focus();
    }
  });
  $$('[data-gallery-image]').forEach(button => button.addEventListener('click', () => {
    const img = $('[data-main-image]');
    img.src = button.dataset.galleryImage;
    img.removeAttribute('srcset');
    $$('[data-gallery-image]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  }));
  $$('[data-product-form]').forEach(form => {
    const dimensions = $('[data-size-pairs]', form);
    if (!dimensions) return;
    const pairs = JSON.parse(dimensions.dataset.sizePairs);
    const sideA = $('[data-side-a]', form), sideB = $('[data-side-b]', form);
    const syncSides = () => {
      const compatible = pairs.filter(pair => pair[0] === sideA.value).map(pair => pair[1]);
      sideB.disabled = !sideA.value;
      [...sideB.options].forEach(option => {
        option.hidden = !!option.value && !compatible.includes(option.value);
        option.disabled = option.hidden;
      });
      if (sideB.value && !compatible.includes(sideB.value)) sideB.value = '';
      if (compatible.length === 1) sideB.value = compatible[0];
    };
    sideA.addEventListener('change', syncSides);
    syncSides();
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); }
    });
  });
  const catalog = $('[data-catalog]');
  if (catalog) {
    const cards = $$('[data-product]', catalog);
    const controls = $$('[data-filter]', catalog);
    const initial = new URLSearchParams(location.search);
    controls.forEach(c => { if ([...c.options].some(o => o.value === initial.get(c.dataset.filter))) c.value = initial.get(c.dataset.filter); });
    const apply = () => {
      const filters = Object.fromEntries(controls.map(c => [c.dataset.filter,c.value]));
      let count = 0;
      cards.forEach(card => {
        const pass = (!filters.category || card.dataset.category === filters.category) && (!filters.use || card.dataset.uses.split(',').includes(filters.use)) && (!filters.size || card.dataset.sizes.split(',').includes(filters.size));
        card.hidden = !pass;
        if (pass) count++;
      });
      $('[data-result-count]', catalog).textContent = `${count} ${say('models')}`;
      $('[data-empty]', catalog).hidden = count !== 0;
      const url = new URL(location.href);
      controls.forEach(c => c.value ? url.searchParams.set(c.dataset.filter,c.value) : url.searchParams.delete(c.dataset.filter));
      history.replaceState(null, '', url);
    };
    controls.forEach(c => c.addEventListener('change', apply));
    $('[data-reset]', catalog)?.addEventListener('click', () => { controls.forEach(c => c.value = ''); apply(); });
    apply();
  }
  $$('a[href^="tel:"]').forEach(a => a.addEventListener('click', () => emit('click_phone', { source:location.pathname })));
  $$('a[href^="https://wa.me/"]').forEach(a => a.addEventListener('click', () => emit('click_whatsapp', { source:location.pathname })));
  const quote = $('#GazeboQuote');
  if (quote && $('[data-step]', quote)) {
    const steps = $$('[data-step]', quote);
    const progress = $$('[data-progress]', quote);
    const error = $('[data-form-error]', quote);
    const field = id => $('#q-' + id, quote);
    const params = new URLSearchParams(location.search);
    const modelOptions = [...field('model').options].map(o => ({value:o.value,category:o.dataset.category,element:o}));
    const modelPicker = $('[data-model-picker]', quote);
    const modelDisclosure = $('details', modelPicker);
    const modelChoices = $$('[data-model-choice]', modelPicker);
    const modelCards = modelChoices.filter(button => button.dataset.modelChoice);
    const pageSize = 4;
    let modelPage = 0;
    const matchingCards = () => modelCards.filter(card => !field('category').value || card.dataset.category === field('category').value);
    const modelAction = () => {
      $('[data-model-action]', modelPicker).textContent = say(modelDisclosure.open ? 'close_models' : field('model').value ? 'change_model' : 'view_models');
    };
    const renderModelPage = () => {
      const matching = matchingCards();
      const pages = Math.ceil(matching.length / pageSize);
      modelPage = Math.max(0, Math.min(modelPage, pages - 1));
      const visible = matching.slice(modelPage * pageSize, (modelPage + 1) * pageSize);
      modelCards.forEach(card => { card.hidden = !visible.includes(card); });
      $('[data-model-pagination]', modelPicker).hidden = pages <= 1;
      $('[data-model-page="-1"]', modelPicker).disabled = modelPage === 0;
      $('[data-model-page="1"]', modelPicker).disabled = modelPage >= pages - 1;
      $('[data-model-count]', modelPicker).textContent = `${modelPage * pageSize + 1}–${Math.min((modelPage + 1) * pageSize, matching.length)} / ${matching.length} ${say('models')}`;
    };
    const updateModelPreview = () => {
      const selected = modelCards.find(card => card.dataset.modelChoice === field('model').value);
      modelChoices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.modelChoice === field('model').value)));
      $('[data-model-placeholder]', modelPicker).hidden = !!selected;
      $('[data-model-name]', modelPicker).textContent = selected ? $('[data-choice-name]', selected).textContent : say('help_choose');
      $('[data-model-detail]', modelPicker).textContent = selected ? $('[data-choice-detail]', selected).textContent : say('model_hint');
      for (const holder of $$('[data-model-photo], [data-model-summary-photo]', quote)) {
        holder.replaceChildren();
        holder.hidden = !selected;
        if (selected) {
          const photo = $('img', selected).cloneNode(true);
          photo.sizes = '120px';
          photo.loading = 'eager';
          holder.append(photo);
        }
      }
      const index = matchingCards().indexOf(selected);
      modelPage = index >= 0 ? Math.floor(index / pageSize) : 0;
      renderModelPage();
      modelAction();
    };
    let started = false;
    let currentStep = 1;
    let submitted = false;
    let heightModel;
    const updateHeight = () => {
      const model = field('model').value;
      const fixed = model === 'carport-grifone';
      const rule = field('model').selectedOptions[0]?.dataset || {};
      const height = field('height');
      height.disabled = fixed;
      height.closest('.field').hidden = fixed;
      height.min = rule.heightMin || '100';
      height.max = rule.heightMax || '1000';
      height.step = rule.heightStandard ? '1' : 'any';
      height.required = !!rule.heightStandard;
      if (fixed) height.value = '';
      else if (heightModel !== model) height.value = rule.heightStandard || '';
      heightModel = model;
      $('#q-height-note').hidden = !rule.heightStandard;
    };
    const updateModelOptions = () => {
      const category = field('category').value;
      modelOptions.forEach(o => {o.element.hidden = !!category && !!o.category && o.category !== category;o.element.disabled=o.element.hidden;});
      if (field('model').selectedOptions[0]?.hidden) field('model').value = '';
      $$('[data-carport-option]', quote).forEach(el => { el.hidden = category !== 'carport'; $$('input,select',el).forEach(i => i.disabled=el.hidden); });
      $$('[data-gazebo-option]', quote).forEach(el => { el.hidden = category === 'carport'; $$('input,select',el).forEach(i => i.disabled=el.hidden); });
      updateHeight();
      updateModelPreview();
    };
    const serverErrors = !!$('[data-server-errors]', quote);
    if (!serverErrors) {
      for (const k of ['category','model','use']) {
        const el=field(k); const val=params.get(k);
        if (val && [...el.options].some(o=>o.value===val)) el.value=val;
      }
      const selected=modelOptions.find(o=>o.value===field('model').value);
      if(selected?.category) field('category').value=selected.category;
      const size=(params.get('size')||'').match(/^(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)$/);
      if(size){field('width').value=size[1];field('depth').value=size[2];}
      for (const name of ['width','depth']) {
        const value=(params.get(name)||'').replace(',','.');
        if (/^\d+(?:\.\d+)?$/.test(value) && Number(value)>0) field(name).value=value;
      }
    }
    updateModelOptions();
    if (!serverErrors && !field('height').disabled && /^\d+(?:\.\d+)?$/.test(params.get('height')||'')) field('height').value=params.get('height');
    modelDisclosure.open = !field('model').value;
    modelAction();
    modelPicker.hidden = false;
    $('[data-model-fallback]', quote).hidden = true;
    modelDisclosure.addEventListener('toggle', modelAction);
    field('category').addEventListener('change', () => {
      updateModelOptions();
      modelDisclosure.open = !field('model').value;
      modelAction();
    });
    field('model').addEventListener('change', () => {
      const selected = modelOptions.find(option => option.value === field('model').value);
      if (selected?.category) field('category').value = selected.category;
      updateModelOptions();
    });
    modelChoices.forEach(button => button.addEventListener('click', () => {
      field('model').value = button.dataset.modelChoice;
      field('model').dispatchEvent(new Event('change', {bubbles:true}));
      field('model').dispatchEvent(new Event('input', {bubbles:true}));
      modelDisclosure.open = false;
      modelAction();
      $('summary', modelDisclosure).focus();
      modelDisclosure.scrollIntoView({behavior:'auto',block:'nearest'});
    }));
    $$('[data-model-page]', modelPicker).forEach(button => button.addEventListener('click', () => {
      modelPage += Number(button.dataset.modelPage);
      renderModelPage();
      $('.model-choice:not([hidden])', modelPicker)?.focus();
    }));
    const summary = () => {
      const model=field('model').selectedOptions[0]?.textContent || say('help_choose');
      const w=field('width').value, d=field('depth').value;
      const dimensions=field('unknown').checked || !w || !d?say('size_to_define'):`${w} × ${d} m`;
      const height=!field('height').disabled && field('height').value ? ` · ${say('height')} ${field('height').value} cm` : '';
      $('[data-summary]',quote).textContent=`${model} · ${dimensions}${height} · ${say('quantity')} ${field('quantity').value} · ${field('city').value} ${field('zip').value}`;
    };
    const show = n => {
      currentStep=n;
      steps.forEach(s=>s.hidden=Number(s.dataset.step)!==n);
      progress.forEach(p=>{p.classList.toggle('active',Number(p.dataset.progress)===n); if(Number(p.dataset.progress)===n)p.setAttribute('aria-current','step'); else p.removeAttribute('aria-current');});
      error.hidden=true;
      if(n===2) summary();
      const heading=$('h2',steps.find(s=>+s.dataset.step===n));
      heading?.focus({preventScroll:true});
      if(n!==1 || started) quote.scrollIntoView({behavior:'auto',block:'start'});
    };
    const validStep = n => {
      const step=steps.find(s=>Number(s.dataset.step)===n);
      const invalid=$$('input,select,textarea',step).find(el=>!el.disabled && !el.checkValidity());
      $$('[aria-invalid]',quote).forEach(el=>el.removeAttribute('aria-invalid'));
      if(invalid){invalid.setAttribute('aria-invalid','true');error.textContent=say('required_error');error.hidden=false;invalid.focus();invalid.reportValidity();return false;}
      return true;
    };
    quote.noValidate=true;
    show(1);
    field('unknown').addEventListener('change',()=>{
      ['width','depth'].forEach(id=>field(id).disabled=field('unknown').checked);
    });
    quote.addEventListener('input',()=>{if(!started){started=true;emit('lead_form_start',{source:location.pathname});}});
    $('[data-next]',quote).addEventListener('click',()=>{if(validStep(1)){emit('lead_step_complete',{step:1,category:field('category').value,model:field('model').value});show(2);}});
    $('[data-back]',quote).addEventListener('click',()=>show(1));
    quote.addEventListener('submit', e => {
      if(currentStep===1){e.preventDefault();if(validStep(1))show(2);return;}
      if(!validStep(1)){e.preventDefault();show(1);validStep(1);return;}
      if(!validStep(2) || submitted){e.preventDefault();return;}
      emit('lead_submit_attempt',{category:field('category').value,model:field('model').value});
      if(document.documentElement.dataset.preview==='true'){
        e.preventDefault();
        const message=$('[data-preview-result]',quote);message.hidden=false;message.focus();return;
      }
      try {sessionStorage.removeItem('gp_lead_confirmed_'+location.pathname);} catch {}
      submitted=true;
      const submit=$('[type=submit]',quote);submit.disabled=true;submit.textContent=say('sending');
    });
    window.addEventListener('pageshow',()=>{submitted=false;const b=$('[type=submit]',quote);b.disabled=false;b.textContent=say('send_quote');});
  }
  if ($('[data-grifone-flow]')) {
    $$('.nav-tools > .btn--primary, .mobile-action > .btn--primary').forEach(a => a.setAttribute('href', '#prev'));
  }
  const grifone = $('#GrifoneQuote');
  if (grifone && $('[data-gr-step]', grifone)) {
    const steps = $$('[data-gr-step]', grifone);
    const error = $('[data-gr-error]', grifone);
    const field = id => $('#gr-' + id, grifone);
    let current = 1, started = false, submitted = false;
    const submit = $('[type=submit]', grifone);
    const submitLabel = submit.textContent;
    const details = () => ({category:'carport',model:'carport-grifone'});
    const summarize = () => {
      const values = new FormData(grifone);
      const width = values.get('contact[Larghezza metri]');
      const depth = values.get('contact[Profondita metri]');
      const dimensions = width && depth ? `${width === 'Oltre 30' && field('custom').value ? field('custom').value : width} × ${depth} m` : say('size_to_define');
      $('[data-gr-summary]', grifone).textContent = ['Grifone',dimensions,values.get('contact[Struttura]'),values.get('contact[Telo]')].filter(Boolean).join(' · ');
    };
    const conditional = () => {
      const custom = field('width').value === 'Oltre 30';
      field('custom').disabled = !custom;
      field('custom').required = custom;
      field('custom').closest('.field').hidden = !custom;
      const painted = $('[name="contact[Struttura]"]:checked',grifone)?.value === 'Verniciata';
      field('finish-color').disabled = !painted;
      field('finish-color').closest('.field').hidden = !painted;
      summarize();
    };
    const show = (n, focus=true) => {
      current = n;
      steps.forEach(s => s.hidden = Number(s.dataset.grStep) !== n);
      $$('[data-gr-progress]',grifone).forEach(p => {
        p.classList.toggle('active',Number(p.dataset.grProgress) === n);
        if(Number(p.dataset.grProgress) === n)p.setAttribute('aria-current','step');else p.removeAttribute('aria-current');
      });
      error.hidden = true;
      if(focus){grifone.scrollIntoView({behavior:'auto',block:'start'});$('h3',steps[n-1])?.focus({preventScroll:true});}
    };
    const validate = n => {
      const invalid = $$('input,select,textarea',steps[n-1]).find(el => !el.disabled && !el.checkValidity());
      if(!invalid)return true;
      show(n);
      $$('[aria-invalid]',grifone).forEach(el=>el.removeAttribute('aria-invalid'));
      invalid.setAttribute('aria-invalid','true');
      error.textContent=say('required_error');error.hidden=false;
      invalid.focus();invalid.reportValidity();return false;
    };
    const advance = () => {
      if(validate(current)){emit('lead_step_complete',{...details(),step:current});show(current+1);}
    };
    grifone.noValidate = true;
    conditional();show(1,false);
    grifone.addEventListener('input',()=>{if(!started){started=true;emit('lead_form_start',details());}conditional();});
    grifone.addEventListener('change',conditional);
    $$('[data-gr-next]',grifone).forEach(b=>b.addEventListener('click',advance));
    $$('[data-gr-back]',grifone).forEach(b=>b.addEventListener('click',()=>show(current-1)));
    grifone.addEventListener('submit',e=>{
      if(current<4){e.preventDefault();advance();return;}
      for(let n=1;n<=4;n++)if(!validate(n)){e.preventDefault();return;}
      if(submitted){e.preventDefault();return;}
      emit('lead_submit_attempt',details());
      if(document.documentElement.dataset.preview==='true'){
        e.preventDefault();const result=$('[data-preview-result]',grifone);result.hidden=false;result.focus();return;
      }
      try{sessionStorage.removeItem('gp_lead_confirmed_'+location.pathname);}catch{}
      submitted=true;submit.disabled=true;submit.textContent=say('sending');
    });
    window.addEventListener('pageshow',()=>{submitted=false;submit.disabled=false;submit.textContent=submitLabel;});
  }
  if($('[data-lead-confirmed]')) {
    const record = () => {
      if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()!==true)return;
      const marker='gp_lead_confirmed_'+location.pathname;
      try {if(sessionStorage.getItem(marker)==='yes')return;sessionStorage.setItem(marker,'yes');} catch {}
      emit('generate_lead',{source:'shopify_contact_success'});
    };
    record();
    document.addEventListener('visitorConsentCollected',record,{once:true});
    window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)record();});
  }
  const search=$('[data-search-form]');
  if(search && document.documentElement.dataset.preview==='true') {
    const run=()=>{
      const q=$('[name=q]',search).value.trim().toLocaleLowerCase('it');
      const rows=$$('[data-search-row]');let count=0;
      rows.forEach(row=>{row.hidden=!!q&&!row.textContent.toLocaleLowerCase('it').includes(q);if(!row.hidden)count++;});
      $('[data-search-count]').textContent=`${count} ${say('results')}`;
    };
    $('[name=q]',search).value=new URLSearchParams(location.search).get('q')||'';
    search.addEventListener('submit',e=>{e.preventDefault();run();});run();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
